export default __webpack_public_path__ + "static/media/fa-brands-400.ffbf6fd6.svg";